export type NonDeprecatedMortgageProductFeeType = Exclude<
  MortgageProductFeeType,
  'HOMEBUYERS_FEE' | 'CHAPS_FEE' | 'DISBURSEMENT_FEE'
>
export const mapFeeTypeToCanBeAddedToLoan: { [key in NonDeprecatedMortgageProductFeeType]: CanBeAddedToLoan } = {
  ADMINISTRATION_FEE: 'OPTION_TO_BE_ADDED',
  APPLICATION_FEE: 'PAY_SEPARATELY',
  ARRANGEMENT_FEE: 'OPTION_TO_BE_ADDED',
  ASSESSMENT_FEE: 'PAY_SEPARATELY',
  BOOKING_FEE: 'PAY_SEPARATELY',
  BROKER_FEE: 'OPTION_TO_BE_ADDED',
  CHAPS_TELEGRAPHIC_TRANSFER_FEE: 'OPTION_TO_BE_ADDED',
  COMPLETION_FEE: 'OPTION_TO_BE_ADDED',
  DEEDS_RELEASE_FEE: 'PAY_SEPARATELY',
  LEGAL_FEE: 'PAY_SEPARATELY',
  EARLY_REPAYMENT_CHARGE: 'PAY_SEPARATELY',
  HIGHER_LENDING_CHARGE: 'PAY_SEPARATELY',
  VALUATION_FEE: 'PAY_SEPARATELY',
  INSURANCE_ADMINISTRATION: 'PAY_SEPARATELY',
  LAND_REGISTRY_FEE: 'PAY_SEPARATELY',
  LENDER_CONVEYANCING_FEE: 'PAY_SEPARATELY',
  MASTER_BROKER_FEE: 'OPTION_TO_BE_ADDED',
  MORTGAGE_ACCOUNT_FEE: 'OPTION_TO_BE_ADDED',
  OTHER_FEE: 'PAY_SEPARATELY',
  PACKAGER_FEE: 'OPTION_TO_BE_ADDED',
  PRODUCT_TRANSFER_FEE: 'PAY_SEPARATELY',
  RE_INSPECTION_FEE: 'PAY_SEPARATELY',
  REDEMPTION_ADMIN_FEE: 'PAY_SEPARATELY',
  TITLE_DEEDS_ADMIN_FEE: 'PAY_SEPARATELY',
  INVALID_FEE_TYPE: 'INVALID_CAN_BE_ADDED_TO_LOAN',
  CLAWBACK_FEE: 'PAY_SEPARATELY',
}
